import currency from "currency.js";

export const formatPrice = (price: number, integerDecimals = true) => {
  const isIntegerPrice = price % 100 === 0;
  return currency(price / 100, {
    precision: !integerDecimals && isIntegerPrice ? 0 : 2,
  }).format(true);
};

export const formatPriceWithFreeText = (price: number, freeText = "Free") => {
  return price === 0 ? freeText : formatPrice(price);
};

export const centsToDollars = (price: number) => price / 100;
export const dollarsToCents = (dollars: number) => dollars * 100;
